import React from "react";
import { useTranslation } from "react-i18next";

import "../../../services/i18n/config";
import events from "../../../lib/events";
import { ModalScreenshotData } from "../../../types";
import BlueButton from "../../Button/BlueButton/BlueButton";
import RoundedCard from "../../RoundedCard/RoundedCard";
import Base, { BaseModalProps } from "../Base/Base";

type Props = BaseModalProps & {
  data: ModalScreenshotData;
};

const Snapshot: React.FunctionComponent<Props> = ({ data, onClose }: Props) => {
  const { t } = useTranslation();
  const [comment, setComment] = React.useState("");
  return (
    <Base onClose={onClose}>
      <div data-test-id='snapshot-modal-content' className='flex flex-col space-y-4 w-full'>
        <div className='flex flex-col items-center space-y-4'>
          <span className='text-xl font-bold text-center'>{t("snapshot")}</span>
          <RoundedCard className='border-blue-500 border shadow-lg rounded-md'>
            <img src={data.image} className='w-[450px]' alt='Your screenshot' />
          </RoundedCard>
        </div>
        <div className='flex flex-col items-center space-y-4 w-full'>
          <span className='text-xl font-bold text-left w-full'>{t("add_comment")}</span>
          <textarea
            value={comment}
            onChange={events.handleStringChange(setComment)}
            placeholder={t("type_here")}
            className='w-full bg-transparent focus:outline-none rounded-md min-h-[100px] placeholder-white resize-none'
          />
        </div>
        <div className='flex flex-row items-center justify-end'>
          <BlueButton
            onClick={() => {
              data.onSubmit(data.image, comment);
              onClose();
            }}
            className='btn btn-md btn-blue'
          >
            {t("submit")}
          </BlueButton>
        </div>
      </div>
    </Base>
  );
};

export default Snapshot;
